/**this constant contains the details of various career clusters
 * 
 * the file is called by 
 * 1. CCI assessment service
 * 2. CCI Quick assessment service
 * 3. IDEAS assessment service
 * 4. IP assessment service
 * 5. Learning Styles assessment service
 * 6. mini IP assessment service
 * 7. Occupation sort assessment service
 * 8. Reality Check assessment service
 * 9. Work Importance assessment service
 * 10.Millennial Career assessment service
 * 11. Education model
 * 12. Program Studies model
 * 13. Financial Aid model
 * 14. Career model
 * if a state wants previous cluster details, they can use 'previousClusterDetails' constant
 * 
*/


export const clusterDetails = {
    cls_110100: {
        clusterName: 'Agriculture', clusterIconValue: 'icon-clu_agriculture',
        clusterId: '110100', clusterBgColor: '#47bf2a'
    },
    cls_110200: {
        clusterName: 'Construction', clusterIconValue: 'icon-clu_architecture',
        clusterId: '110200', clusterBgColor: '#6c777e'
    },
    cls_110300: {
        clusterName: 'Arts, Entertainment, & Design', clusterIconValue: 'icon-clu_arts',
        clusterId: '110300', clusterBgColor: '#ffa100'
    },
    cls_110400: {
        clusterName: 'Management & Entrepreneurship', clusterIconValue: 'icon-clu_business',
        clusterId: '110400', clusterBgColor: '#003eb6'
    },
    cls_110500: {
        clusterName: 'Education', clusterIconValue: 'icon-clu_education_and_training',
        clusterId: '110500', clusterBgColor: '#00b7c3'
    },
    cls_110600: { clusterName: 'Financial Services', clusterIconValue: 'icon-clu_finance', clusterId: '110600', clusterBgColor: '#ef3f42' },
    cls_110700: {
        clusterName: 'Public Service & Safety', clusterIconValue: 'icon-clu_government',
        clusterId: '110700', clusterBgColor: '#00ad83'
    },
    cls_110800: {
        clusterName: 'Healthcare & Human Services',
        clusterIconValue: 'icon-clu_health_science', clusterId: '110800', clusterBgColor: '#af006b'
    },
    cls_110900: {
        clusterName: 'Hospitality, Events, & Tourism', clusterIconValue: 'icon-clu_hospitality_and_tourism',
        clusterId: '110900', clusterBgColor: '#e0119d'
    },
    cls_111000: {
        clusterName: 'Human Services',
        clusterIconValue: 'icon-clu_human_services', clusterId: '111000', clusterBgColor: '#88cc2a'
    },
    cls_111100: {
        clusterName: 'Digital Technology', clusterIconValue: 'icon-clu_information_technology',
        clusterId: '111100', clusterBgColor: '#b4d600'
    },
    cls_111200: {
        clusterName: 'Law, Public Safety, Corrections, and Security', clusterIconValue: 'icon-clu_law',
        clusterId: '111200', clusterBgColor: '#949ca1'
    },
    cls_111300: {
        clusterName: 'Advanced Manufacturing',
        clusterIconValue: 'icon-clu_manufacturing', clusterId: '111300', clusterBgColor: '#893b1b'
    },
    cls_111400: { clusterName: 'Marketing & Sales', clusterIconValue: 'icon-clu_marketing', clusterId: '111400', clusterBgColor: '#af00b8' },
    cls_111500: {
        clusterName: 'Science, Technology, Engineering, and Mathematics', clusterIconValue: 'icon-clu_science_technology',
        clusterId: '111500', clusterBgColor: '#fdcc2f'
    },
    cls_111600: {
        clusterName: 'Supply Chain & Transportation',
        clusterIconValue: 'icon-clu_transportation_distribution_and_logistics',
        clusterId: '111600', clusterBgColor: '#ff7900'
    },
    cls_111700: {
        clusterName: 'Energy & Natural Resources', clusterIconValue: 'icon-clu_science_technology',
        clusterId: '111700', clusterBgColor: '#011244'
    },
    cls_210100: {
        clusterName: 'Agriculture', clusterIconValue: 'icon-clu_agriculture',
        clusterId: '210100', clusterBgColor: '#47bf2a'
    },
    cls_210200: {
        clusterName: 'Construction', clusterIconValue: 'icon-clu_architecture',
        clusterId: '210200', clusterBgColor: '#6c777e'
    },
    cls_210300: {
        clusterName: 'Arts, Entertainment, & Design', clusterIconValue: 'icon-clu_arts',
        clusterId: '210300', clusterBgColor: '#ffa100'
    },
    cls_210400: {
        clusterName: 'Management & Entrepreneurship', clusterIconValue: 'icon-clu_business',
        clusterId: '210400', clusterBgColor: '#003eb6'
    },
    cls_210500: {
        clusterName: 'Education', clusterIconValue: 'icon-clu_education_and_training',
        clusterId: '210500', clusterBgColor: '#00b7c3'
    },
    cls_210600: { clusterName: 'Financial Services', clusterIconValue: 'icon-clu_finance', clusterId: '210600', clusterBgColor: '#ef3f42' },
    cls_210700: {
        clusterName: 'Public Service & Safety', clusterIconValue: 'icon-clu_government',
        clusterId: '210700', clusterBgColor: '#00ad83'
    },
    cls_210800: {
        clusterName: 'Healthcare & Human Services',
        clusterIconValue: 'icon-clu_health_science', clusterId: '210800', clusterBgColor: '#af006b'
    },
    cls_210900: {
        clusterName: 'Hospitality, Events, & Tourism', clusterIconValue: 'icon-clu_hospitality_and_tourism',
        clusterId: '210900', clusterBgColor: '#e0119d'
    },
    cls_211000: {
        clusterName: 'Human Services',
        clusterIconValue: 'icon-clu_human_services', clusterId: '211000', clusterBgColor: '#88cc2a'
    },
    cls_211100: {
        clusterName: 'Digital Technology', clusterIconValue: 'icon-clu_information_technology',
        clusterId: '211100', clusterBgColor: '#b4d600'
    },
    cls_211200: {
        clusterName: 'Law, Public Safety, Corrections, and Security', clusterIconValue: 'icon-clu_law',
        clusterId: '211200', clusterBgColor: '#949ca1'
    },
    cls_211300: {
        clusterName: 'Advanced Manufacturing',
        clusterIconValue: 'icon-clu_manufacturing', clusterId: '211300', clusterBgColor: '#893b1b'
    },
    cls_211400: { clusterName: 'Marketing & Sales', clusterIconValue: 'icon-clu_marketing', clusterId: '211400', clusterBgColor: '#af00b8' },
    cls_211500: {
        clusterName: 'Science, Technology, Engineering, and Mathematics', clusterIconValue: 'icon-clu_science_technology',
        clusterId: '211500', clusterBgColor: '#fdcc2f'
    },
    cls_211600: {
        clusterName: 'Supply Chain & Transportation',
        clusterIconValue: 'icon-clu_transportation_distribution_and_logistics',
        clusterId: '211600', clusterBgColor: '#ff7900'
    },
    cls_211700: {
        clusterName: 'Energy & Natural Resources', clusterIconValue: 'icon-clu_science_technology',
        clusterId: '211700', clusterBgColor: '#011244'
    },
};

/**if a state wants previous cluster details */
export const previousClusterDetails = {
    cls_110100: {
        clusterName: 'Agriculture, Food & Natural Resources', clusterIconValue: 'icon-clu_agriculture',
        clusterId: '110100', clusterBgColor: '#47bf2a'
    },
    cls_110200: {
        clusterName: 'Architecture & Construction', clusterIconValue: 'icon-clu_architecture',
        clusterId: '110200', clusterBgColor: '#6c777e'
    },
    cls_110300: {
        clusterName: 'Arts, A/V Technology & Communications', clusterIconValue: 'icon-clu_arts',
        clusterId: '110300', clusterBgColor: '#ffa100'
    },
    cls_110400: {
        clusterName: 'Business Management & Administration', clusterIconValue: 'icon-clu_business',
        clusterId: '110400', clusterBgColor: '#003eb6'
    },
    cls_110500: {
        clusterName: 'Education & Training', clusterIconValue: 'icon-clu_education_and_training',
        clusterId: '110500', clusterBgColor: '#00b7c3'
    },
    cls_110600: { clusterName: 'Finance', clusterIconValue: 'icon-clu_finance', clusterId: '110600', clusterBgColor: '#ef3f42' },
    cls_110700: {
        clusterName: 'Government and Public Administration', clusterIconValue: 'icon-clu_government',
        clusterId: '110700', clusterBgColor: '#00ad83'
    },
    cls_110800: {
        clusterName: 'Health Science',
        clusterIconValue: 'icon-clu_health_science', clusterId: '110800', clusterBgColor: '#af006b'
    },
    cls_110900: {
        clusterName: 'Hospitality and Tourism', clusterIconValue: 'icon-clu_hospitality_and_tourism',
        clusterId: '110900', clusterBgColor: '#e0119d'
    },
    cls_111000: {
        clusterName: 'Human Services',
        clusterIconValue: 'icon-clu_human_services', clusterId: '111000', clusterBgColor: '#88cc2a'
    },
    cls_111100: {
        clusterName: 'Information Technology', clusterIconValue: 'icon-clu_information_technology',
        clusterId: '111100', clusterBgColor: '#b4d600'
    },
    cls_111200: {
        clusterName: 'Law, Public Safety, Corrections, and Security', clusterIconValue: 'icon-clu_law',
        clusterId: '111200', clusterBgColor: '#949ca1'
    },
    cls_111300: {
        clusterName: 'Manufacturing',
        clusterIconValue: 'icon-clu_manufacturing', clusterId: '111300', clusterBgColor: '#893b1b'
    },
    cls_111400: { clusterName: 'Marketing', clusterIconValue: 'icon-clu_marketing', clusterId: '111400', clusterBgColor: '#af00b8' },
    cls_111500: {
        clusterName: 'Science, Technology, Engineering, and Mathematics', clusterIconValue: 'icon-clu_science_technology',
        clusterId: '111500', clusterBgColor: '#fdcc2f'
    },
    cls_111600: {
        clusterName: 'Transportation, Distribution and Logistics',
        clusterIconValue: 'icon-clu_transportation_distribution_and_logistics',
        clusterId: '111600', clusterBgColor: '#ff7900'
    },
    cls_111700: {
        clusterName: 'Energy & Natural Resources', clusterIconValue: 'icon-clu_science_technology',
        clusterId: '111700', clusterBgColor: '#011244'
    },
    cls_210100: {
        clusterName: 'Agriculture, Food & Natural Resources', clusterIconValue: 'icon-clu_agriculture',
        clusterId: '210100', clusterBgColor: '#47bf2a'
    },
    cls_210200: {
        clusterName: 'Architecture & Construction', clusterIconValue: 'icon-clu_architecture',
        clusterId: '210200', clusterBgColor: '#6c777e'
    },
    cls_210300: {
        clusterName: 'Arts, A/V Technology & Communications', clusterIconValue: 'icon-clu_arts',
        clusterId: '210300', clusterBgColor: '#ffa100'
    },
    cls_210400: {
        clusterName: 'Business Management & Administration', clusterIconValue: 'icon-clu_business',
        clusterId: '210400', clusterBgColor: '#003eb6'
    },
    cls_210500: {
        clusterName: 'Education & Training', clusterIconValue: 'icon-clu_education_and_training',
        clusterId: '210500', clusterBgColor: '#00b7c3'
    },
    cls_210600: { clusterName: 'Finance', clusterIconValue: 'icon-clu_finance', clusterId: '210600', clusterBgColor: '#ef3f42' },
    cls_210700: {
        clusterName: 'Government and Public Administration', clusterIconValue: 'icon-clu_government',
        clusterId: '210700', clusterBgColor: '#00ad83'
    },
    cls_210800: {
        clusterName: 'Health Science',
        clusterIconValue: 'icon-clu_health_science', clusterId: '210800', clusterBgColor: '#af006b'
    },
    cls_210900: {
        clusterName: 'Hospitality and Tourism', clusterIconValue: 'icon-clu_hospitality_and_tourism',
        clusterId: '210900', clusterBgColor: '#e0119d'
    },
    cls_211000: {
        clusterName: 'Human Services',
        clusterIconValue: 'icon-clu_human_services', clusterId: '211000', clusterBgColor: '#88cc2a'
    },
    cls_211100: {
        clusterName: 'Information Technology', clusterIconValue: 'icon-clu_information_technology',
        clusterId: '211100', clusterBgColor: '#b4d600'
    },
    cls_211200: {
        clusterName: 'Law, Public Safety, Corrections, and Security', clusterIconValue: 'icon-clu_law',
        clusterId: '211200', clusterBgColor: '#949ca1'
    },
    cls_211300: {
        clusterName: 'Manufacturing',
        clusterIconValue: 'icon-clu_manufacturing', clusterId: '211300', clusterBgColor: '#893b1b'
    },
    cls_211400: { clusterName: 'Marketing', clusterIconValue: 'icon-clu_marketing', clusterId: '211400', clusterBgColor: '#af00b8' },
    cls_211500: {
        clusterName: 'Science, Technology, Engineering, and Mathematics', clusterIconValue: 'icon-clu_science_technology',
        clusterId: '211500', clusterBgColor: '#fdcc2f'
    },
    cls_211600: {
        clusterName: 'Transportation, Distribution and Logistics',
        clusterIconValue: 'icon-clu_transportation_distribution_and_logistics',
        clusterId: '211600', clusterBgColor: '#ff7900'
    },
    cls_211700: {
        clusterName: 'Energy & Natural Resources', clusterIconValue: 'icon-clu_science_technology',
        clusterId: '211700', clusterBgColor: '#011244'
    },
};

export const dashboardCardIcons = {
    'art': '/assets/images/artistic-color.svg',
    'cle': '/assets/images/keyboard-color.svg',
    'int': '/assets/images/has-family-support-color.svg',
    'lan': '/assets/images/pen-color.svg',
    'lea': '/assets/images/mick-color.svg',
    'man': '/assets/images/tools-color.svg',
    'mus': '/assets/images/music-color.svg',
    'num': '/assets/images/tv-color.svg',
    'org': '/assets/images/orgnization-color.svg',
    'per': '/assets/images/enterprise-color.svg',
    'sci': '/assets/images/testtube-color.svg',
    'soc': '/assets/images/social-color.svg',
    'tec': '/assets/images/conventional-color.svg',
    'MEC': '/assets/images/tools-color.svg',
    'PRO': '/assets/images/service-color.svg',
    'NAT': '/assets/images/sun-color.svg',
    'MTH': '/assets/images/tv-color.svg',
    'SCI': '/assets/images/testtube-color.svg',
    'MED': '/assets/images/doct-color.svg',
    'ART': '/assets/images/music-color.svg',
    'WRI': '/assets/images/pen-color.svg',
    'COM': '/assets/images/heart-color.svg',
    'EDU': '/assets/images/apple-color.svg',
    'CHI': '/assets/images/child-care-color.svg',
    'PUB': '/assets/images/mick-color.svg',
    'BUS': '/assets/images/brefcase-color.svg',
    'SAL': '/assets/images/enterprise-color.svg',
    'OFF': '/assets/images/keyboard-color.svg',
    'FOO': '/assets/images/food-color.svg',
    'conventional': '/assets/images/keyboard-color.svg',
    'artistic': '/assets/images/artistic-color.svg',
    'realistic': '/assets/images/realistic-color.svg',
    'investigative': '/assets/images/investigative-color.svg',
    'social': '/assets/images/social-color.svg',
    'enterprising': '/assets/images/enterprise-color.svg',
    'independence': '/assets/images/independent-color.svg',
    'support': '/assets/images/support-color.svg',
    'workingconditions': '/assets/images/working-conditions-color.svg',
    'relationships': '/assets/images/relationships-color.svg',
    'recognition': '/assets/images/recognition-color.svg',
    'achievement': '/assets/images/has-a-need-to-achieve-color.svg',
    'communication': '/assets/images/plp-4-1-color.svg',
    'collaboration': '/assets/images/plp-4-2-color.svg',
    'thinking': '/assets/images/plp-4-3-color.svg',
    'professional': '/assets/images/plp-4-4-color.svg',
    'initiative': '/assets/images/plp-4-6-color.svg',
    'intergenerational': '/assets/images/plp-4-7-color.svg',
    'organizational': '/assets/images/plp-4-8-color.svg',
    'legal': '/assets/images/plp-4-9-color.svg',
    'financial': '/assets/images/plp-4-5-color.svg'
};
export const dashboardCardPrintIcons = {
    'art': 'icon-artistic',
    'cle': 'icon-keyboard',
    'int': 'icon-has_family_support',
    'lan': 'icon-pen',
    'lea': 'icon-mick',
    'man': 'icon-tools',
    'mus': 'icon-music',
    'num': 'icon-tv',
    'org': 'icon-orgnization',
    'per': 'icon-enterprise',
    'sci': 'icon-testtube',
    'soc': 'icon-social',
    'tec': 'icon-conventional',
    'MEC': 'icon-tools',
    'PRO': 'icon-service',
    'NAT': 'icon-sun',
    'MTH': 'icon-tv',
    'SCI': 'icon-testtube',
    'MED': 'icon-doct',
    'ART': 'icon-music',
    'WRI': 'icon-pen',
    'COM': 'icon-heart',
    'EDU': 'icon-apple',
    'CHI': 'icon-child_care',
    'PUB': 'icon-mick',
    'BUS': 'icon-brefcase',
    'SAL': 'icon-enterprise',
    'OFF': 'icon-keyboard',
    'FOO': 'icon-food',
    'conventional': 'icon-keyboard',
    'artistic': 'icon-artistic',
    'realistic': 'icon-realistic',
    'investigative': 'icon-investigative',
    'social': 'icon-social',
    'enterprising': 'icon-enterprise',
    'independence': 'icon-independent',
    'support': 'icon-has_family_support',
    'workingconditions': 'icon-working_conditions',
    'relationships': 'icon-relationships',
    'recognition': 'icon-recognition',
    'achievement': 'icon-has_a_need_to_achieve',
    'communication': 'icon-plp_4_1',
    'collaboration': 'icon-plp_4_2',
    'thinking': 'icon-plp_4_3',
    'professional': 'icon-plp_4_4',
    'initiative': 'icon-plp_4_6',
    'intergenerational': 'icon-plp_4_7',
    'organizational': 'icon-plp_4_8',
    'legal': 'icon-plp_4_9',
    'financial': 'icon-plp_4_5'
};
